import React, { useState, useEffect } from 'react';
import Immutable from 'immutable';

import './style.scss';

const NavigationVertical = ({ pages, onGoto, index }) => {
  const [_pages, setPages] = useState(Immutable.Map());

  // Delay the pages as to allow for the CSS animation.
  useEffect(() => {
    setTimeout(() => {
      setPages(pages);
    }, 500);
  }, [pages]);

  return (
    <div className={`NavigationVertical ${(index < 0) ? 'NavigationVertical--hidden' : ''}`}>
      <div className="NavigationVertical__wrapper">
        <div className="NavigationVertical__wrapper__container">
          {_pages.map((page, i) => {
            return (
              <div key={i} className={`NavigationVertical__item ${index === i ? 'active' : ''}`} onClick={() => onGoto(i)}>
                <span className="NavigationVertical__item__title">{page.getIn(['entity', 'field_title', 0, 'value'])}</span>
                <span className="NavigationVertical__item__icon" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NavigationVertical;
